import { render, staticRenderFns } from "./TptPatientFilterBox.vue?vue&type=template&id=6df43ae3&scoped=true"
import script from "./TptPatientFilterBox.vue?vue&type=script&lang=js"
export * from "./TptPatientFilterBox.vue?vue&type=script&lang=js"
import style0 from "./TptPatientFilterBox.vue?vue&type=style&index=0&id=6df43ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df43ae3",
  null
  
)

export default component.exports